"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const work_registration_forms_1 = require("@Const/work-registration-forms");
const contexts_1 = require("@App/contexts");
const fetch_type_enum_1 = require("@App/kit/components/WorkItemV2/fetch-type-enum");
const HistoryExtendedWorkItem_1 = __importDefault(require("@Components/WorkItemV2/History/HistoryExtendedWorkItem"));
const ClaimSubmissionStep = () => {
    const { workStore, claimToolStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    (0, react_1.useEffect)(() => {
        workStore.setWizardStepValidation(true);
        return () => {
            workStore.destroyViewWork();
            workStore.setWorkDraftToLocal(work_registration_forms_1.CLEAR_WORK_DRAFT);
            workStore.setWizardStepValidation(false);
            claimToolStore.resetClaimingToolWizard();
        };
    }, []);
    return (react_1.default.createElement("div", { className: "claim-submission-step" },
        react_1.default.createElement("h5", null, "Submit"),
        react_1.default.createElement("div", { className: 'description' }, "Your claim has been submitted. You can review your submission in Registration History. Please note: newly submitted claims can take 1-3 weeks to be processed."),
        react_1.default.createElement("div", { className: 'history-item' }, workStore.workDraftLocal && (react_1.default.createElement(HistoryExtendedWorkItem_1.default, { work: workStore.workDraftLocal, fetchType: fetch_type_enum_1.FetchType.MLC, getId: () => '' })))));
};
exports.default = (0, mobx_react_1.observer)(ClaimSubmissionStep);
